import React from 'react';
import { IntlProvider } from 'react-intl';

import enMessages from './locales/en.json';
import plMessages from './locales/pl.json';

const messages: { [key: string]: any } = {
    en: enMessages,
    pl: plMessages,
};

const getLocale = () => {
    const savedLocale = localStorage.getItem('locale');
    return savedLocale || (navigator.language.startsWith('en') ? 'en' : 'pl');
};

interface I18nProviderProps {
  children: React.ReactNode;
}

const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
    const locale = getLocale();

    return (
        <IntlProvider locale={locale} messages={messages[locale]}>
            {children}
        </IntlProvider>
    );
};

export default I18nProvider;
